import config from '@config/config';

import api from '../../../lib/api';
import { ResourceFetch } from '../../../meta/types/api';
import { NewNesletterContact, NewsletterContact } from '../../../meta/types/newsletter';

const { GET, DELETE, POST } = api;

const NEWSLETTER_RESOURE_BASE_PATH = `${config.managementServiceBasePath}/api/v1/management/newsletter`;

export interface NewsletterResource {
  getContact: ResourceFetch<NewsletterContact, { email: string }>;
  createContact: ResourceFetch<NewsletterContact, NewNesletterContact>;
  deleteContact: ResourceFetch<void, { email: string }>;
}

const NewsletterResource: NewsletterResource = {
  createContact: POST(NEWSLETTER_RESOURE_BASE_PATH),
  getContact: GET(`${NEWSLETTER_RESOURE_BASE_PATH}/:email`),
  deleteContact: DELETE(`${NEWSLETTER_RESOURE_BASE_PATH}/:email`),
};

export default NewsletterResource;
